export default __webpack_public_path__ + "ab1a9d43f946d117f5ffa679aa2b5496.png";